"use strict";

exports.__esModule = true;
exports.SortableField = SortableField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function SortableField(props) {
  var setSortable = props.setSortable,
    setSortOrder = props.setSortOrder,
    defaultSortOrder = props.defaultSortOrder,
    enableSort = props.enableSort;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableColumnFields.sortable.label", "Sorting"),
    helperText: translate("DataTableColumnFields.sortable.helperText", "Is the column sortable.")
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: enableSort,
    label: translate("DataTableColumnFields.sortable.fieldValue", "Enable Sorting"),
    onChange: function onChange() {
      return setSortable(!enableSort);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("DataTableColumnFields.sortOrder.label", "Default Sort Order"),
    helperText: translate("DataTableColumnFields.sortOrder.helperText", "The initial sort order for the column.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: defaultSortOrder,
    onChange: function onChange(e) {
      return setSortOrder(e.target.value);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "NONE"
  }, translate("MetricValueFields.sortOrder.none.label", "None")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "ASC"
  }, translate("MetricValueFields.sortOrder.ascending.label", "Ascending")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "DESC"
  }, translate("MetricValueFields.sortOrder.descending.label", "Descending"))))));
}